const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsSampleSelector`,
			DefaultInputExtensions: [ 'MaterialsSampleSelector' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsSampleSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					value=""
				/>
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					{~D:Record.Macro.InputChangeHandler~}
					value=""
				/>
				<a id="MATERIALS-ENTITY-FILTER-TOGGLE-{~D:Record.Macro.RawHTMLID~}"
					class="button is-ghost is-pulled-right p-0 is-size-7 {~FilterToggleHidden:Record~} {~FilterToggleDisabled:Record~}"
					title="Show all (ignore filters)"
					onclick="_Pict.providers.MaterialsEntitySelector.toggleFilterOverride('{~D:Record.Macro.RawHTMLID~}', '{~D:Record.DataAddress~}')">
					<span class="icon"><i class="fas fa-toggle-off"></i></span><span class="icon-text">Show All</span>
				</a>
				<label for="MATERIALS-ENTITY-SELECT-FOR-{~D:Record.Macro.RawHTMLID~}" class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
				<div class="field has-addons has-addons-right">
					<p class="control control-status select is-fullwidth">
						<span class="control-status-icon"></span>
						<select
							id="MATERIALS-ENTITY-SELECT-FOR-{~D:Record.Macro.RawHTMLID~}"
							{~D:Record.Macro.ControlAttr~}
							{~Required:Record~}
							{~Disabled:Record~}
							onchange="{~P~}.views['{~D:Context[0].Hash~}'].inputDataRequest('{~D:Record.Hash~}', event);"
						>
							<option value="">Select...</option>
						</select>
					</p>
					<p class="control">
						<button class="button is-link" type="button" {~Disabled:Record~} onclick="_Pict.views.HeadlightPaneSamples.openSamplePanelFromAdvancedButton(event)">
							<span class="icon is-small">
								<i class="fas fa-bars-filter"></i>
							</span>
						</button>
					</p>
				</div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-MaterialsSampleSelector',
			DefaultInputExtensions: [ 'MaterialsSampleSelector' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsSampleSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field mb-0">
				<p class="control control-status select is-fullwidth">
					<span class="control-status-icon"></span>
					<input
						id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						tabindex="-1"
						value=""
					/>
					<input
						id="MATERIALS-ENTITY-SELECT-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						tabindex="-1"
						{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsSampleSelector',
			DefaultInputExtensions: [ 'MaterialsSampleSelector' ],
			Template: /*HTML-Partial*/`
					value="" />
					<select
						id="MATERIALS-ENTITY-SELECT-TABULAR-DROPDOWN-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						{~D:Record.Macro.ControlAttr~}
						{~D:Record.Macro.HTMLName~}
						data-i-pictselect="MATERIALS-ENTITY-SELECT-TABULAR-FOR-{~D:Record.Macro.RawHTMLID~}"
						{~Required:Record~}
						{~Disabled:Record~}
						onchange="_Pict.views['{~D:Context[0].Hash~}'].inputDataRequestTabular('{~D:Context[2].Group~}', '{~D:Record.PictForm.InputIndex~}', '{~D:Context[2].Key~}', event)"
					></select>
				</p>
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsSampleSelector`,
			DefaultInputExtensions: [ 'MaterialsSampleDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsSampleSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					value=""
				/>
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control">
						<div
							id="MATERIALS-ENTITY-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
							disabled="disabled"
						></div>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-MaterialsSampleSelector`,
			DefaultInputExtensions: [ 'MaterialsSampleDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsSampleSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<p class="control">
				<input
					id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="hidden"
					tabindex="-1"
					value=""
				/>
				<input
					id="MATERIALS-ENTITY-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="text"
					class="input"
					{~D:Record.Macro.HTMLName~}
					{~D:Record.Macro.InformaryTabular~}
					disabled="disabled" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsSampleSelector',
			Template: /*HTML-Partial*/`
				value="" />
			</p>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsSampleSelector`,
			DefaultInputExtensions: [ 'MaterialsSampleDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsSampleSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<input
					id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					value=""
				/>
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div
							id="MATERIALS-ENTITY-DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input is-static wrap-selections-for-print"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-MaterialsSampleSelector`,
			DefaultInputExtensions: [ 'MaterialsSampleDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsSampleSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<div
				id="MATERIALS-ENTITY-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				class="input is-static wrap-selections-for-print"
				{~D:Record.Macro.ControlAttr~}
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsSampleSelector',
			Template: /*HTML-Partial*/`
			></div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;
